var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCoe(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5833 11.9166L11.7833 10.1166L12.6333 9.26659L14.4333 11.0666L13.5833 11.9166ZM11.4166 4.71659L10.5666 3.88325L12.3666 2.08325L13.2166 2.93325L11.4166 4.71659ZM4.58332 4.71659L2.78332 2.91659L3.63332 2.06659L5.43332 3.86659L4.58332 4.71659ZM2.41665 11.9166L1.56665 11.0666L3.36665 9.28325L4.21665 10.1166L2.41665 11.9166ZM5.86665 11.0999L7.99998 9.83325L10.15 11.0999L9.58332 8.69992L11.4333 7.11659L8.98332 6.89992L7.99998 4.61659L7.01665 6.89992L4.56665 7.11659L6.43332 8.69992L5.86665 11.0999ZM4.04998 13.5833L5.09998 9.14992L1.59998 6.16659L6.19998 5.76659L7.99998 1.58325L9.79998 5.78325L14.4 6.16659L10.9 9.14992L11.95 13.5833L7.99998 11.2333L4.04998 13.5833Z",
    fill: "#1C1B1F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoe);
export default __webpack_public_path__ + "static/media/COE.0e8a8c0d313d937d1a1569ecf1258518.svg";
export { ForwardRef as ReactComponent };